import React from 'react';
import { motion } from 'framer-motion';
import { CTAButton } from './CTAButton';
import { BookOpen, Clock, Moon, Shield, Calendar, HeartHandshake, MessageCircle } from 'lucide-react';
export function IncludesSection() {
  const items = [{
    icon: BookOpen,
    text: 'El Protocolo 10 paso a paso (Oreja → Mandíbula/Cuello → Pecho)'
  }, {
    icon: Clock,
    text: 'Versión 3 minutos (para cortar el pico sin irte de la escena)'
  }, {
    icon: Shield,
    text: 'Versión 7 minutos (antes del grito)'
  }, {
    icon: Moon,
    text: 'Versión 12 minutos (noche / 3AM / pre-sueño)'
  }, {
    icon: HeartHandshake,
    text: 'Ajustes específicos para la Mamá Agotada (ruido, contacto, culpa, rabia)'
  }, {
    icon: Calendar,
    text: 'Plan de 7 días para convertirlo en reflejo sin disciplina heroica'
  }, {
    icon: MessageCircle,
    text: 'Scripts de reparación (20 segundos) cuando ya pasó'
  }];
  return <section className="py-20 md:py-32 px-6 bg-cream-100" data-id="element-82">
      <div className="max-w-3xl mx-auto" data-id="element-83">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-3xl md:text-4xl font-serif font-bold text-charcoal mb-12 text-center" data-id="element-84">
          Qué incluye exactamente
        </motion.h2>

        <div className="bg-white rounded-2xl shadow-sm border border-terracotta/10 overflow-hidden mb-12" data-id="element-85">
          {items.map((item, index) => <motion.div key={index} initial={{
          opacity: 0,
          x: -10
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.05
        }} className={`flex items-start p-6 ${index !== items.length - 1 ? 'border-b border-cream-200' : ''}`} data-id="element-86">
              <div className="bg-cream-200 p-2 rounded-lg text-terracotta mr-4 shrink-0" data-id="element-87">
                <item.icon className="w-5 h-5" data-id="element-88" />
              </div>
              <span className="text-lg text-charcoal-light" data-id="element-89">{item.text}</span>
            </motion.div>)}
        </div>

        <div className="text-center" data-id="element-90">
          <CTAButton text="Quiero tener el protocolo a mano" size="large" data-id="element-91" />
        </div>
      </div>
    </section>;
}